class Utils {
    getRandomNumbers() {
        var today = new Date().toLocaleDateString().toString();
        var now = today.split('/').join('');
    
        var val = Math.floor(10000 + Math.random() * 9000);
        // comment console console.log("ini today"+now);
        // comment console console.log(val)
        var randomNumber = now + val.toString();
    
        return randomNumber
    }

    baseurlFoUsers() {
        return process.env.VUE_APP_BASE_URL_FO_USER
        // return "https://103.214.113.160:1155"
    }

    baseUrlLms() {
        
        return process.env.VUE_APP_BASE_URL_LMS
        // return "http://103.214.113.160:2255"
    }

    formValidation(idForm,characterAllow) {
        document.getElementById(idForm).onkeypress = function (e) {
            var chr = String.fromCharCode(e.which);
            if (characterAllow.indexOf(chr) < 0) return false;
        };
    }
}
  
export default new Utils();